    var DetectBrowser = {
        init: function() {
            this.browser = this.searchString( this.dataBrowser ) || 'Other';
            this.version = this.searchVersion( navigator.userAgent ) || this.searchVersion( navigator.appVersion ) || 'Unknown';
        },
        searchString: function(data) {
            for ( var i = 0; i < data.length; i++ ) {
                var dataString = data[i].string;
                this.versionSearchString = data[i].subString;
                if ( dataString.indexOf( data[i].subString ) !== -1 ) {
                    return data[i].identity;
                }
            }
        },
        searchVersion: function(dataString) {
            var index = dataString.indexOf( this.versionSearchString );
            if ( index === -1 ) {
                return;
            }
            var rv = dataString.indexOf( 'rv:' );
            if ( this.versionSearchString === 'Trident' && rv !== -1 ) {
                return parseFloat( dataString.substring( rv + 3 ) );
            } else {
                return parseFloat( dataString.substring( index + this.versionSearchString.length + 1 ) );
            }
        },
        dataBrowser: [ {
            string: navigator.userAgent,
            subString: 'Chrome',
            identity: 'Chrome'
        }, {
            string: navigator.userAgent,
            subString: 'Safari',
            identity: 'Safari'
        }, {
            string: navigator.userAgent,
            subString: 'Firefox',
            identity: 'Firefox'
        }, {
            string: navigator.userAgent,
            subString: 'Edge',
            identity: 'MS Edge'
        }, {
            string: navigator.userAgent,
            subString: 'MSIE',
            identity: 'Explorer'
        }, {
            string: navigator.userAgent,
            subString: 'Trident',
            identity: 'Explorer'
        }, {
            string: navigator.userAgent,
            subString: 'Opera',
            identity: 'Opera'
        }, {
            string: navigator.userAgent,
            subString: 'OPR',
            identity: 'Opera'
        },
        ]
    };
    
    var swiperHomeOne;
    
    $(function() {

        if ( location.search.includes( 'bag=1' ) ) {
            if ( ! $( '.bag' ).hasClass( 'active' ) ) {
                $( '.bag' ).addClass( 'delay' );
                setTimeout(function() {
                    $( '.bag' ).addClass( 'active' );
                }, 100 );
            }
        }        
        if ( location.href.includes('/cart') ) {
            let url = localStorage.getItem( 'previousURL' ) || '';
            if ( ! url.includes( 'bag=1' ) ) {
                url += ( url.includes( '?' ) ? '&' : '?' ) + 'bag=1';
            }
            location.href = url;
        }
    
        const $body = $( 'body' );
    
        var os = [
            'iphone',
            'ipad',
            'windows',
            'mac',
            'linux'
        ];
    
        var match = navigator.appVersion.toLowerCase().match(new RegExp(os.join('|')));
    
        if (match) {
            $( 'body' ).addClass( match[0] );
        };
    
        DetectBrowser.init();
    
        var bv = DetectBrowser.browser;
    
        if( bv == 'Chrome' ) {
            $( 'body' ).addClass( 'chrome' );
        }
        else if( bv == 'Safari' ) {
            $( 'body' ).addClass( 'safari' );
        }
        else if( bv == 'Firefox' ) {
            $( 'body' ).addClass( 'firefox' );
        }
        else if( bv == 'MS Edge' ) {
            $( 'body' ).addClass( 'edge' );
        }
        else if( bv == 'Explorer' ) {
            $( 'body' ).addClass( 'ie' );
        }
        else if( bv == 'Opera' ) {
            $( 'body' ).addClass( 'opera' );
        }
    
        $( '.shop .collection .results .sections .section .title .button.text a, .resources .sections .content .blocks .block.one .content ul li a, .product .overview .content .form .blocks.one .block .rating .text.two a, .blog .navigation .content .links ul li a, .account .addresses .content .sections .section .blocks .block .addresses .address:last-child .blocks .block .button.small a' ).click(function() {
            if ( location.pathname.replace(/^\//, '' ) == this.pathname.replace(/^\//, '' ) && location.hostname == this.hostname ) {
                var target = $(this.hash);
                target = target.length ? target : $( '[name=' + this.hash.slice(1) +']' );
                if (target.length) {
                    $( 'html, body' ).animate({
                        scrollTop: target.offset().top
                    }, 1375);
                    return false;
                }
            }
        });
    
        $(window).on( 'scroll', function(event) {
            const classes   = 'scroll',
                  target    = 'body',
                  winWidth  = 3860,
                  offset    = 70,
                  scrollTop = $(window).scrollTop();
            if ( window.innerWidth <= winWidth ) {
                if ( scrollTop > offset ) {
                    if ( $(window).innerWidth() < 3860 ) {
                        $( "meta[name='theme-color']" ).attr( 'content', '#FEFEFE' );
                    };
                    $body.addClass(classes);
                } else {
                    if ( $(window).innerWidth() < 3860 ) {
                        $( "meta[name='theme-color']" ).attr( 'content', '#FEFEFE' );
                    };
                    $body.removeClass(classes);
                }
            }
        });
    
        $(window).on( 'scroll', function(event) {
            const classes   = 'one',
                  target    = 'body',
                  winWidth  = 3860,
                  offset    = 114,
                  scrollTop = $(window).scrollTop();
            if ( window.innerWidth <= winWidth ) {
                if ( scrollTop > offset ) {
                    $body.addClass(classes);
                } else {
                    $body.removeClass(classes);
                }
            }
        });
    
        $(window).on( 'scroll', function(event) {
            const classes   = 'two',
                  target    = 'body',
                  winWidth  = 3860,
                  offset    = window.innerWidth > 900 ? 141 : 202,
                  scrollTop = $(window).scrollTop();
            if ( window.innerWidth <= winWidth ) {
                if ( scrollTop > offset ) {
                    $body.addClass(classes);
                } else {
                    $body.removeClass(classes);
                }
            }
        });

        $( '.legislation .close, .legislation .overlay' ).click(function() {
            $( '.legislation' ).removeClass( 'active' );
        });      
    
        setTimeout(function() {
            $( '.home section.prompt' ).addClass( 'active one' );
        }, 1000);
    
        setTimeout(function() {
            $( '.home section.prompt' ).removeClass( 'active one' );
        }, 5250);

        setTimeout(function() {
            $( '.home section.prompt' ).addClass( 'active two' );
        }, 8500);
    
        setTimeout(function() {
            $( '.home section.prompt' ).removeClass( 'active two' );
        }, 12750);

        setTimeout(function() {
            $( '.home section.prompt' ).addClass( 'active three' );
        }, 16000);
    
        setTimeout(function() {
            $( '.home section.prompt' ).removeClass( 'active three' );
        }, 20250);

        setTimeout(function() {
            $( '.home section.prompt' ).addClass( 'active four' );
        }, 22500);
    
        setTimeout(function() {
            $( '.home section.prompt' ).removeClass( 'active four' );
        }, 26750);

        setTimeout(function() {
            $( '.home section.prompt' ).addClass( 'active five' );
        }, 29000);
    
        setTimeout(function() {
            $( '.home section.prompt' ).removeClass( 'active five' );
        }, 33250);
        
        $( '.subscribe.alt .content .sections .section .blocks .block .close, .subscribe.alt .overlay' ).click(function() {
            $( '.subscribe.alt' ).removeClass( 'active' );
            Utils.setCookie( 'welcomeSubscription', true);
        });        
    
        $( 'header .logo, header .menu.main .list li, .submenu .container, header .submenu .overlay' ).hover(function() {
            $( 'body' ).removeClass( 'click hover glitters paints lacquers-and-waxes powders grouts sealants tools links' );
        });
    
        $( 'header .submenu .overlay' ).hover(function() {
            if( $( 'body' )[0].className.includes( 'click' ) ) {
                return;
            }
            $( 'body' ).removeClass( 'hover glitters paints lacquers-and-waxes powders grouts sealants tools links' );
        });
    
        $( 'header .menu.main .list li.glitters, header .submenu.glitters .container' ).hover(function() {
            $( 'body' ).addClass( 'hover glitters' );
        });
    
        $( 'header .menu.main .list li.paints, header .submenu.paints .container' ).hover(function() {
            $( 'body' ).addClass( 'hover paints' );
        });

        $( 'header .menu.main .list li.lacquers-and-waxes, header .submenu.lacquers-and-waxes .container' ).hover(function() {
            $( 'body' ).addClass( 'hover lacquers-and-waxes' );
        });      
    
        $( 'header .menu.main .list li.powders, header .submenu.powders .container' ).hover(function() {
            $( 'body' ).addClass( 'hover powders' );
        });
    
        $( 'header .menu.main .list li.grouts, header .submenu.grouts .container' ).hover(function() {
            $( 'body' ).addClass( 'hover grouts' );
        });
    
        $( 'header .menu.main .list li.sealants, header .submenu.sealants .container' ).hover(function() {
            $( 'body' ).addClass( 'hover sealants' );
        });

        $( 'header .menu.main .list li.tools, header .submenu.tools .container' ).hover(function() {
            $( 'body' ).addClass( 'hover tools' );
        });      
    
        $( 'header .menu.icons .search.alt.one' ).click(function() {
            $( 'body' ).addClass( 'hover links' );
        });
    
        $(document).ready( function() {
            var $window = $(window);
            function checkWidth() {
                var windowsize = $window.width();
                if ( windowsize > 900 ) {
                    $( 'header .submenu.links .container' ).hover( function() {
                        $( 'body' ).addClass( 'hover links' );
                    });
                }
            }
            checkWidth();
            $(window).resize( checkWidth );
        });
    
        $( 'header .menu.icons .search.alt.two' ).click(function() {
            $( 'header .submenu.links' ).addClass( 'delay' );
            setTimeout(function() {
                $( 'header .submenu.links' ).addClass( 'active' );
            }, 100 );
        });
    
        $( 'header .submenu.links .close' ).click(function() {
            $( 'body' ).removeClass( 'hover links' );
        });
      
        $( 'header .submenu.links .close, header .submenu.links .overlay' ).click(function() {
            $( 'header .submenu.links' ).removeClass( 'active' );
            setTimeout(function() {
                $( 'header .submenu.links' ).removeClass( 'delay' );
            }, 750 );
        });
    
        $( 'header .menu.icon.one' ).click(function() {
            if ( clickDisabled ) {
                return;
            }
            clickDisabled = true;
            setTimeout(function() {
                clickDisabled = false;
            }, 750 );
            $( 'header .menu.alt' ).addClass( 'delay' );
            setTimeout(function() {
                $( 'header .menu.alt' ).addClass( 'active' );
            }, 100 );
        });
    
        $( 'header .menu.alt .slides .slide.one .close, header .menu.alt .overlay' ).click(function() {
            if ( clickDisabled ) {
                return;
            }
            clickDisabled = true;
            setTimeout(function() {
                clickDisabled = false;
            }, 750 );
            $( 'header .menu.alt' ).removeClass( 'active' );
            setTimeout(function() {
                $( 'header .menu.alt' ).removeClass( 'delay' );
            }, 750 );
        });
    
        $( 'header .menu.alt .slides .slide .content .blocks .block .title' ).click(function() {
            const $el = $( 'header .menu.alt .slides .slide .content .blocks .block .title' );
            $el.not(this).removeClass( 'active' );
            $el.not(this).parent().find( '.content' ).css( 'height', '0' );
            $(this).toggleClass( 'active' );
            const $content = $(this).parent().find( '.content' );
            let height = '0';
            if ( $(this).hasClass( 'active' ) ) {
                height = $content.prop( 'scrollHeight' ) + 'px';
            }
            $content.css( 'height', height );
        });
    
        $( 'header .menu.alt .slides .slide.one .close, header .menu.alt .overlay' ).click(function() {
            setTimeout(function() {
                $( 'body' ).removeClass( 'glitters powders paints lacquers-and-waxes grouts sealants tools' );
            }, 750 );
        });
    
        $( 'header .menu.alt .slides .slide .content .blocks .block .title' ).click(function() {
            $( 'body' ).removeClass( 'back one two' );
        });
    
        $( 'header .menu.alt .slides .slide .content .blocks .block.glitters .title' ).click(function() {
            $( 'body' ).removeClass( 'paints lacquers-and-waxes powders grouts sealants tools' );
            $( 'body' ).addClass( 'click glitters' );
        });
    
        $( 'header .menu.alt .slides .slide .content .blocks .block.paints .title' ).click(function() {
            $( 'body' ).removeClass( 'glitters lacquers-and-waxes powders grouts sealants tools' );
            $( 'body' ).addClass( 'click paints' );
        });

        $( 'header .menu.alt .slides .slide .content .blocks .block.lacquers-and-waxes .title' ).click(function() {
            $( 'body' ).removeClass( 'glitters paints powders grouts sealants tools' );
            $( 'body' ).addClass( 'click lacquers-and-waxes' );
        });      
    
        $( 'header .menu.alt .slides .slide .content .blocks .block.powders .title' ).click(function() {
            $( 'body' ).removeClass( 'glitters paints lacquers-and-waxes grouts sealants tools' );
            $( 'body' ).addClass( 'click powders' );
        });
    
        $( 'header .menu.alt .slides .slide .content .blocks .block.grouts .title' ).click(function() {
            $( 'body' ).removeClass( 'glitters paints lacquers-and-waxes powders sealants tools' );
            $( 'body' ).addClass( 'click grouts' );
        });
    
        $( 'header .menu.alt .slides .slide .content .blocks .block.sealants .title' ).click(function() {
            $( 'body' ).removeClass( 'glitters paints lacquers-and-waxes powders grouts tools' );
            $( 'body' ).addClass( 'click sealants' );
        });

        $( 'header .menu.alt .slides .slide .content .blocks .block.tools .title' ).click(function() {
            $( 'body' ).removeClass( 'glitters paints lacquers-and-waxes powders grouts sealants' );
            $( 'body' ).addClass( 'click tools' );
        });
    
        $( 'header .menu.alt .slides .slide .close' ).click(function() {
            $( 'body' ).removeClass( 'back one two' );
        });
    
        $( 'header .menu.alt .slides .slide.two .close' ).click(function() {
            $( 'body' ).addClass( 'back one' );
        });
    
        $( 'header .menu.alt .slides .slide.three .close' ).click(function() {
            $( 'body' ).addClass( 'back two' );
        });
    
        $( '.home .categories .category .content .blocks.one .block .content .slider .slides .slide .toggle' ).click(function() {
            $(this).toggleClass( 'active' );
        });
    
        $( '.category .products .product .content .blocks.one .block .content .slider .slides .slide .toggle' ).click(function() {
            $(this).toggleClass( 'active' );
        });

        $( '.shop.collection .filters.theme .content .attributes .attribute .content .terms .term' ).click(function() {
            $(this).toggleClass( 'active' );
        });

        $( '.shop.collection .navigation.alt .content .links ul li.one' ).click(function() {
            $( '.shop.collection .filters' ).toggleClass( 'alt' );
            $(this).toggleClass( 'alt' );
        });      
    
        $( '.shop.collection .navigation.alt .content .links ul li.two' ).click(function() {
            $( '.shop.collection .filters' ).addClass( 'delay' );
            setTimeout(function() {
                $( '.shop.collection .filters' ).addClass( 'active' );
            }, 100 );
        });
    
        $( '.shop.collection .filters .close, .shop.collection .filters .overlay, .shop.collection .filters .action .button.large' ).click(function() {
            $( '.shop.collection .filters' ).removeClass( 'active' );
            setTimeout(function() {
                $( '.shop.collection .filters' ).removeClass( 'delay' );
            }, 750 );
        });
    
        $( '.shop.collection .results .result.alt .banner .button.small.alt' ).click(function() {
            $( 'body' ).addClass( 'overflow' );
            $( '.shop.collection .results.alt' ).addClass( 'delay' );
            setTimeout(function() {
                $( '.shop.collection .results.alt' ).addClass( 'active' );
            }, 100 );
        });
    
        $( '.shop.collection .results.alt .close, .shop.collection .results.alt .overlay' ).click(function() {
            $( 'body' ).removeClass( 'overflow' );
            $( '.shop.collection .results.alt' ).removeClass( 'active' );
            setTimeout(function() {
                $( '.shop.collection .results.alt' ).removeClass( 'delay' );
            }, 750 );
        });

        $( '.shop .collection .description .content .blocks .block .buttons .button' ).click(function() {
            $( '.shop .collection .description .content .blocks' ).toggleClass( 'active' );
        });

        $( '.shop .collection .description .content .blocks .block .text h2:first-of-type ~ *' ).wrapAll( '<div class="accordion"><div class="panels"></div></div>' )

        $( '.shop .collection .description .content .blocks .block .text h3' ).each(function() {
            $(this).nextUntil( 'h3' ).addBack().wrapAll( '<div class="panel" /> ');
        });

        $( '.shop .collection .description .content .blocks .block .text h3' ).each(function() {
            $(this).nextUntil( 'h3' ).wrapAll( '<div class="content" /> ');
        });
      
        $( '.shop .collection .description.two .content .blocks .block' ).append( $( '.shop .collection .description.one .content .blocks .block .text h2' ) );   
        $( '.shop .collection .description.two .content .blocks .block' ).append( $( '.shop .collection .description.one .content .blocks .block .text .accordion' ) );   
      
        $( '.shop .collection .description.two .content .blocks .block .accordion .panels h3' ).click(function() {
            const $el = $( '.shop .collection .description.two .content .blocks .block .accordion .panels h3' );
            $el.not(this).removeClass( 'active' );
            $el.not(this).parent().find( '.content' ).css( 'height', '0' );
            $(this).toggleClass( 'active' );
            const $content = $(this).parent().find( '.content' );
            let height = '0';
            if ( $(this).hasClass( 'active' ) ) {
                height = $content.prop( 'scrollHeight' ) + 'px';
            }
            $content.css( 'height', height );
        });

        $( '.product .banner .content .slider .price' ).click(function() {
            if ( clickDisabled ) {
                return;
            }
            clickDisabled = true;
            setTimeout(function() {
                clickDisabled = false;
            }, 750 );
            $( '.product .overview .content .form .blocks .block .tabs .tab.price .content .modal' ).addClass( 'delay' );
            setTimeout(function() {
                $( '.product .overview .content .form .blocks .block .tabs .tab.price .content .modal' ).addClass( 'active' );  
            }, 100 );
        });
    
        $( '.product .overview .content .form .blocks .block .tabs .tab.price .content .modal .close, .product .overview .content .form .blocks .block .tabs .tab.price .content .modal .overlay' ).click(function() {
            if ( clickDisabled ) {
                return;
            }
            clickDisabled = true;
            setTimeout(function() {
                clickDisabled = false;
            }, 750 );
            $( '.product .overview .content .form .blocks .block .tabs .tab.price .content .modal' ).removeClass( 'active' );
            setTimeout(function() {
                $( '.product .overview .content .form .blocks .block .tabs .tab.price .content .modal' ).removeClass( 'delay' );
            }, 750 );
        });
    
        $( '.product .banner .content .slider .delivery, .product .overview .content .form .blocks .block .tabs .tab.delivery .title' ).click(function() {
            if ( clickDisabled ) {
                return;
            }
            clickDisabled = true;
            setTimeout(function() {
                clickDisabled = false;
            }, 750 );
            $( '.product .overview .content .form .blocks .block .tabs .tab.delivery .content .modal' ).addClass( 'delay' );
            setTimeout(function() {
                $( '.product .overview .content .form .blocks .block .tabs .tab.delivery .content .modal' ).addClass( 'active' );
                if ( ! $( '.tab.delivery .modal .panels .panel h2.active' ).length ) {
                    var $el = $( '.tab.delivery .modal .panels .panel:first-child h4' );
                    $el.addClass( 'active' );
                    var $content = $el.closest( '.panel' ).find( '.content' );
                    var height = '0';
                    if ( $el.hasClass( 'active' ) ) {
                        height = $content.prop( 'scrollHeight' ) + 'px';
                    }
                    $content.css( 'height', height );
                }
            }, 100 );
        });
    
        $( '.product .overview .content .form .blocks .block .tabs .tab.delivery .content .modal .close, .product .overview .content .form .blocks .block .tabs .tab.delivery .content .modal .overlay' ).click(function() {
            if ( clickDisabled ) {
                return;
            }
            clickDisabled = true;
            setTimeout(function() {
                clickDisabled = false;
            }, 750 );
            $( '.product .overview .content .form .blocks .block .tabs .tab.delivery .content .modal' ).removeClass( 'active' );
            setTimeout(function() {
                $( '.product .overview .content .form .blocks .block .tabs .tab.delivery .content .modal' ).removeClass( 'delay' );
            }, 750 );
        });
    
        $( '.product .overview .content .form .blocks .block .tabs .tab.returns .title' ).click(function() {
            if ( clickDisabled ) {
                return;
            }
            clickDisabled = true;
            setTimeout(function() {
                clickDisabled = false;
            }, 750 );
            $( '.product .overview .content .form .blocks .block .tabs .tab.returns .content .modal' ).addClass( 'delay' );
            setTimeout(function() {
                $( '.product .overview .content .form .blocks .block .tabs .tab.returns .content .modal' ).addClass( 'active' );                
                if ( ! $( '.tab.returns .modal .panels .panel h2.active' ).length ) {
                    var $el = $( '.tab.returns .modal .panels .panel:first-child h4' );
                    $el.addClass( 'active' );
                    var $content = $el.closest( '.panel' ).find( '.content' );
                    var height = '0';
                    if ( $el.hasClass( 'active' ) ) {
                        height = $content.prop( 'scrollHeight' ) + 'px';
                    }
                    $content.css( 'height', height );
                }
            }, 100 );
        });
    
        $( '.product .overview .content .form .blocks .block .tabs .tab.returns .content .modal .close, .product .overview .content .form .blocks .block .tabs .tab.returns .content .modal .overlay' ).click(function() {
            if ( clickDisabled ) {
                return;
            }
            clickDisabled = true;
            setTimeout(function() {
                clickDisabled = false;
            }, 750 );
            $( '.product .overview .content .form .blocks .block .tabs .tab.returns .content .modal' ).removeClass( 'active' );
            setTimeout(function() {
                $( '.product .overview .content .form .blocks .block .tabs .tab.returns .content .modal' ).removeClass( 'delay' );
            }, 750 );
        });
    
        $( '.product .overview .content .form .blocks .block .tabs .tab.description .title' ).click(function() {
            if ( clickDisabled ) {
                return;
            }
            clickDisabled = true;
            setTimeout(function() {
                clickDisabled = false;
            }, 750 );
            $( '.product .overview .content .form .blocks .block .tabs .tab.description .content .modal' ).addClass( 'delay' );
            setTimeout(function() {
                $( '.product .overview .content .form .blocks .block .tabs .tab.description .content .modal' ).addClass( 'active' );                
                // showFirstDescription();              
            }, 100 );   
        });

        $( '.product .overview .content .form .blocks .block .tabs .tab.description .title' ).click(function() {
            if ( ! $( '.tab.description .modal .panels .panel h2.active' ).length ) {
                showFirstDescription();
            }
        });

        function showFirstDescription() {
            var $el = $( '.tab.description .modal .panels .panel:first-child h2' );
            $el.addClass( 'active' );
            var $content = $el.parent().find( '.content' );
            var height = '0';
            if ( $el.hasClass( 'active' ) ) {
                height = $content.prop( 'scrollHeight' ) + 'px';
            }
            $content.css( 'height', height );
        }
    
        $( '.product .overview .content .form .blocks .block .tabs .tab.description .content .modal .close, .product .overview .content .form .blocks .block .tabs .tab.description .content .modal .overlay' ).click(function() {
            if ( clickDisabled ) {
                return;
            }
            clickDisabled = true;
            setTimeout(function() {
                clickDisabled = false;
            }, 750 );
            $( '.product .overview .content .form .blocks .block .tabs .tab.description .content .modal' ).removeClass( 'active' );
            setTimeout(function() {
                $( '.product .overview .content .form .blocks .block .tabs .tab.description .content .modal' ).removeClass( 'delay' );
            }, 750 );
        });

        $( '.product .overview .content .form .blocks .block .tabs .tab .content .modal .content .accordion .panels h2' ).each(function() {
            $(this).nextUntil( 'h2' ).addBack().wrapAll( '<div class="panel" /> ');
        });

        $( '.product .overview .content .form .blocks .block .tabs .tab .content .modal .content .accordion .panels h2' ).each(function() {
            $(this).nextUntil( 'h2' ).wrapAll( '<div class="content" /> ');
        });
    
        $( '.product .tabs .tab .content .modal .content .accordion .panels .title' ).click(function() {
            const $el = $( '.product .tabs .tab .content .modal .content .accordion .panels .title' );
            $el.not(this).removeClass( 'active' );
            $el.not(this).closest( '.panel' ).find( '.content' ).css( 'height', '0' );
            $(this).toggleClass( 'active' );
            const $content = $(this).closest( '.panel' ).find( '.content' );
            let height = '0';
            if ( $(this).hasClass( 'active' ) ) {
                height = $content.prop( 'scrollHeight' ) + 'px';
            }
            $content.css( 'height', height );
        });
    
        $( '.product .overview .content .form .blocks .block .tabs .tab .content .modal .content .accordion .panels h2' ).click(function() {
            const $el = $( '.product .overview .content .form .blocks .block .tabs .tab .content .modal .content .accordion .panels h2' );
            $el.not(this).removeClass( 'active' );
            $el.not(this).parent().find( '.content' ).css( 'height', '0' );
            $(this).toggleClass( 'active' );
            const $content = $(this).parent().find( '.content' );
            let height = '0';
            if ( $(this).hasClass( 'active' ) ) {
                height = $content.prop( 'scrollHeight' ) + 'px';
            }
            $content.css( 'height', height );
        });

        $( '.product .overview .content .form .blocks .block .tabs .tab.downloads .title' ).click(function() {
            if ( clickDisabled ) {
                return;
            }
            clickDisabled = true;
            setTimeout(function() {
                clickDisabled = false;
            }, 750 );
            $( '.product .overview .content .form .blocks .block .tabs .tab.downloads .content .modal' ).addClass( 'delay' );
            setTimeout(function() {
                $( '.product .overview .content .form .blocks .block .tabs .tab.downloads .content .modal' ).addClass( 'active' );
            }, 100 );
        });
    
        $( '.product .overview .content .form .blocks .block .tabs .tab.downloads .content .modal .close, .product .overview .content .form .blocks .block .tabs .tab.downloads .content .modal .overlay' ).click(function() {
            if ( clickDisabled ) {
                return;
            }
            clickDisabled = true;
            setTimeout(function() {
                clickDisabled = false;
            }, 750 );
            $( '.product .overview .content .form .blocks .block .tabs .tab.downloads .content .modal' ).removeClass( 'active' );
            setTimeout(function() {
                $( '.product .overview .content .form .blocks .block .tabs .tab.downloads .content .modal' ).removeClass( 'delay' );
            }, 750 );
        });  
    
        $( '.button.medium.returns' ).click(function() {
            $( '.account .modal' ).addClass( 'delay' );
            setTimeout(function() {
                $( '.account .modal' ).addClass( 'active' );
            }, 100);
        });
    
        $( '.account .modal .close, .account .modal .overlay' ).click(function() {
            $( '.account .modal' ).removeClass( 'active' );
            setTimeout(function() {
                $( '.account .modal' ).removeClass( 'delay' );
            }, 750);
        });
    
        $( '.product .overview .content .form .blocks .block .tabs .tab .content .modal .content .accordion .panels .panel .title.active' ).each(function(){
            const $el = $( '.product .overview .content .form .blocks .block .tabs .tab .content .modal .content .accordion .panels .panel .title' );
            const $content = $(this).parent().find( '.content' );
            $content.css( 'height', $content.prop( 'scrollHeight' ) + 'px' );
        });
    
        var hours = new Date();
        if ( hours.getHours() >= 8 && hours.getHours() <= 16 ) {
            $( 'footer .content .blocks.one .block .links .blocks .block:nth-child(3) .title, header .menu.alt .slides .slide .content .blocks .block.alt.two .blocks .block.contact' ).addClass( 'online' );
        }
    
        $( '.checkbox' ).click(function() {
            $(this).toggleClass( 'active' );
        });
    
        $(document).on( 'touchstart, click', '.icon.show', function() {
            $( '.icon.show i' ).toggleClass( 'icons8-eye icons8-hide' );
            var input = $( $(this).attr( 'toggle' ) );
            if ( input.attr( 'type' ) == 'password' ) {
                input.attr( 'type', 'text' );
            } else {
                input.attr( 'type', 'password' );
            }
        });
    
        const swiperGlobalOne = new Swiper( '.prompt .slider', {
            containerModifierClass: 'slide-',
            noSwipingClass: 'alt',
            slideActiveClass: 'active',
            slideBlankClass: 'blank',
            slideClass: 'slide',
            slideNextClass: 'next',
            slidePrevClass: 'previous',
            slideVisibleClass: 'visible',
            wrapperClass: 'slides',
            speed: 1250,
            centeredSlides: true,
            autoHeight: true,
            autoplay: {
                delay: 6250,
                disableOnInteraction: false,
            },
        });

        /*
    
        const swiperGlobalTwo = new Swiper( '.brands .slider', {
            containerModifierClass: 'slider-',
            slideActiveClass: 'active',
            slideBlankClass: 'blank',
            slideClass: 'slide',
            slideNextClass: 'next',
            slidePrevClass: 'previous',
            slideVisibleClass: 'visible',
            spaceBetween: 0,
            wrapperClass: 'slides',
            speed: 1000,
            loop: true,
            autoplay: {
                disableOnInteraction: false,
            },
            breakpoints: {
                0: {
                    autoplay: {
                        delay: 1000,
                    },
                    slidesPerView: 2,
                },
                600: {
                    autoplay: {
                        delay: 1000,
                    },
                    slidesPerView: 4,
                },
                750: {
                    autoplay: {
                        delay: 2500,
                    },
                    slidesPerView: 6,
                },
                1025: {
                    autoplay: {
                        delay: 2500,
                    },
                    slidesPerView: 8,
                }
            }
        });

        */

        const $trustpilotSlides = $( '.trustpilot .slider .slides .slide' );
        $trustpilotSlides.sort(function(a, b) {
            var dateA = $(a).data( 'date' );
            var dateB = $(b).data( 'date' );
            if (dateA > dateB) return -1;
            if (dateA < dateB) return 1;
            return 0;
        });
        var $limitedTrustpilotSlides = $trustpilotSlides.slice(0, 20);
        $( '.trustpilot .slider .slides' ).html( $limitedTrustpilotSlides );

        /*

        const swiperGlobalThree = new Swiper( '.trustpilot .slider', {
            containerModifierClass: 'slide-',
            slideActiveClass: 'active',
            slideBlankClass: 'blank',
            slideClass: 'slide',
            slideNextClass: 'next',
            slidePrevClass: 'previous',
            slideVisibleClass: 'visible',
            wrapperClass: 'slides',
            speed: 750,
            navigation: {
                disabledClass: 'disabled',
                prevEl: '.trustpilot .navigation .buttons .button.one',
                nextEl: '.trustpilot .navigation .buttons .button.two',
            },
            pagination: {
                bulletClass: 'icon',
                bulletActiveClass: 'active',
                el: '.trustpilot .pagination .icons',
                dynamicBullets: true,
            },
            breakpoints: {
                0: {
                    spaceBetween: 12,
                    slidesPerView: 1,
                },
                600: {
                    spaceBetween: 18,
                    slidesPerView: 2,
                },
                900: {
                    spaceBetween: 18,
                    slidesPerView: 1,
                },
                1200: {
                    spaceBetween: 18,
                    slidesPerView: 2,
                },
                1500: {
                    spaceBetween: 18,
                    slidesPerView: 3,
                }              
            }
        });

        */

        const swiperPostTwo = new Swiper( '.post .related .slider', {
            containerModifierClass: 'slide-',
            noSwipingClass: 'alt',
            slideActiveClass: 'active',
            slideBlankClass: 'blank',
            slideClass: 'slide',
            slideNextClass: 'next',
            slidePrevClass: 'previous',
            slideVisibleClass: 'visible',
            wrapperClass: 'slides',
            speed: 750,
            navigation: {
                disabledClass: 'disabled',
                nextEl: '.post .related .slider .buttons .next',
                prevEl: '.post .related .slider .buttons .previous',
            },
            breakpoints: {
                300: {
                    spaceBetween: 12,
                    slidesPerView: 2
                },
                600: {
                    spaceBetween: 18,
                    slidesPerView: 3
                },
                900: {
                    spaceBetween: 24,
                    slidesPerView: 4
                }
            }
        });

        swiperHomeOne = new Swiper( '.home .banner .slider', {
            containerModifierClass: 'slider-',
            noSwipingClass: 'alt',
            slideActiveClass: 'active',
            slideBlankClass: 'blank',
            slideClass: 'slide',
            slideNextClass: 'next',
            slidePrevClass: 'previous',
            slideVisibleClass: 'visible',
            wrapperClass: 'slides',
            speed: 1000,
            autoHeight: true,
            slidesPerGroup: 1,
            spaceBetween: 20,
            loop: true,
            noSwiping: true,
        });
      
    });
    
    $( 'header .bag .container .content.mini-cart .totals .button.large' ).click(function(e) {
        // e.preventDefault();
    });
    
    var clickDisabled = false;
    $( '.product .overview .content form .fields .attributes .attribute.shape .content .modal .content .tones .tone .title' ).click(function() {
        const $el = $( '.product .overview .content form .fields .attributes .attribute.shape .content .modal .content .tones .tone .title' );
        $el.not(this).removeClass( 'active' );
        $el.not(this).parent().find( '.content' ).css( 'height', '0' );
        $(this).toggleClass( 'active' );
        const $content = $(this).parent().find( '.content' );
        let height = '0';
        if ( $(this).hasClass( 'active' ) ) {
            height = $content.prop( 'scrollHeight' ) + 'px';
        }
        $content.css( 'height', height );
    });
    
    $( '.product .overview .content .form .blocks .block .tabs .tab.message .content .modal .close, .product .overview .content .form .blocks .block .tabs .tab.message .content .modal .overlay' ).click(function() {
        if ( clickDisabled ) {
            return;
        }
        clickDisabled = true;
        setTimeout(function() {
            clickDisabled = false;
        }, 750 );
        $( '.product .overview .content .form .blocks .block .tabs .tab.message .content .modal' ).removeClass( 'active' );
        setTimeout(function() {
            $( '.product .overview .content .form .blocks .block .tabs .tab.message .content .modal' ).removeClass( 'delay' );
        }, 750 );
    });
    
    // $( '.product .overview .content form .fields .attributes .attribute.color .content .modal .content .tones .tone .title' ).click(function() {
        // const $el = $( '.product .overview .content form .fields .attributes .attribute.color .content .modal .content .tones .tone .title' );
        // $el.not(this).removeClass( 'active' );
        // $el.not(this).parent().find( '.content' ).css( 'height', '0' );
        // $(this).toggleClass( 'active' );
        // const $content = $(this).parent().find( '.content' );
        // let height = '0';
        // if ( $(this).hasClass( 'active' ) ) {
            // height = $content.prop( 'scrollHeight' ) + 'px';
        // }
        // $content.css( 'height', height );
    // });
    
    $( '.product .overview .content form .fields .attributes .attribute.color .content .select' ).click(function() {
        if ( clickDisabled ) {
            return;
        }
        clickDisabled = true;
        $( '.header__action-list.menu.icons' ).addClass( 'modal-state-visible' );
        $( '.shopify-section.shopify-section__header' ).attr( 'style', 'z-index: -1' );
        $( 'body' ).addClass( 'modal-state' );
        $(this).next().find( '.swatch' ).each(function(i) {
            var dataUrl = this.dataset.lazyLocation;
            if ( dataUrl ) {
                $(this).css( 'background-image', 'url(' + dataUrl + ')' );
            }
        });
        setTimeout(function() {
            clickDisabled = false;
        }, 550 );
        $( '.product .overview .content form .fields .attribute.color .content .modal' ).addClass( 'delay' );
        setTimeout(function() {
            $( '.product .overview .content form .fields .attribute.color .content .modal' ).addClass( 'active' );
        }, 100 );
    });
    
    $( '.product .overview .content form .fields .attributes .attribute.color .content .modal .content .tones .tone .content .terms .term, .product .overview .content form .fields .attributes .attribute.color .content .modal .close, .product .overview .content form .fields .attributes .attribute.color .content .modal .overlay' ).click(function() {
        if ( clickDisabled ) {
            return;
        }
        clickDisabled = true;
        setTimeout(function() {
            clickDisabled = false;
        }, 750 );
        $( '.product .overview .content form .fields .attributes .attribute.color .content .modal' ).removeClass( 'active' );
        setTimeout(function() {
            $( '.product .overview .content form .fields .attributes .attribute.color .content .modal' ).removeClass( 'delay' );
            $( 'body' ).removeClass( 'modal-state' );
            $( '.header__action-list.menu.icons' ).removeClass( 'modal-state-visible' );
            $( '.shopify-section.shopify-section__header' ).attr( 'style', '' );
        }, 750 );
    });
    
    $( '.product .overview .content form .fields .attributes .attribute.color .content .modal .layout .button.square' ).click(function() {
        $( '.product .overview .content form .fields .attributes .attribute.color .content .modal .content' ).removeClass( 'grid list' );
    });
    
    $( '.product .overview .content form .fields .attributes .attribute.color .content .modal .layout .button.square' ).click(function() {
        $( '.product .overview .content form .fields .attributes .attribute.color .content .modal .layout .button.square' ).removeClass( 'active' );
    });
    
    $( '.product .overview .content form .fields .attributes .attribute.color .content .modal .layout .button.square' ).click(function() {
        $( '.product .overview .content form .fields .attributes .attribute.color .content .modal .content .tones .tone .title' ).removeClass( 'active' );
        $( '.product .overview .content form .fields .attributes .attribute.color .content .modal .content .tones .tone .content' ).css( 'height', '0' );
    });
    
    $( '.product .overview .content form .fields .attributes .attribute.color .content .modal .layout .button.square' ).click(function() {
        $(this).addClass( 'active' );
    });
    
    $( '.product .overview .content form .fields .attributes .attribute.color .content .modal .layout .button.square.grid' ).click(function() {
        $( '.product .overview .content form .fields .attributes .attribute.color .content .modal .content' ).addClass( 'grid' );
    });
    
    $( '.product .overview .content form .fields .attributes .attribute.color .content .modal .layout .button.square.list' ).click(function() {
        $( '.product .overview .content form .fields .attributes .attribute.color .content .modal .content' ).addClass( 'list' );
    });
    
    $( '.product .overview .content form .fields .attributes .attribute.shape .content .select' ).click(function() {
        if ( clickDisabled ) {
            return;
        }
        clickDisabled = true;
        $( '.header__action-list.menu.icons' ).addClass( 'modal-state-visible' );
        $( '.shopify-section.shopify-section__header' ).attr( 'style', 'z-index: -1' );
        $( 'body' ).addClass( 'modal-state' );
        setTimeout(function() {
            clickDisabled = false;
        }, 550 );
        $( '.product .overview .content form .fields .attribute.shape .content .modal' ).addClass( 'delay' );
        setTimeout(function() {
            $( '.product .overview .content form .fields .attribute.shape .content .modal' ).addClass( 'active' );
        }, 100 );
    });
    
    $( '.product .overview .content form .fields .attributes .attribute.shape .content .modal .content .tones .tone .content .terms .term, .product .overview .content form .fields .attributes .attribute.shape .content .modal .close, .product .overview .content form .fields .attributes .attribute.shape .content .modal .overlay' ).click(function() {
        if ( clickDisabled ) {
            return;
        }
        clickDisabled = true;
        setTimeout(function() {
            clickDisabled = false;
        }, 750 );
        $( '.product .overview .content form .fields .attributes .attribute.shape .content .modal' ).removeClass( 'active' );
    
        setTimeout(function() {
            $( '.product .overview .content form .fields .attributes .attribute.shape .content .modal' ).removeClass( 'delay' );
            $( 'body' ).removeClass( 'modal-state' );
            $( '.header__action-list.menu.icons' ).removeClass( 'modal-state-visible' );
            $( '.shopify-section.shopify-section__header' ).attr( 'style', '' );
        }, 750 );
    });
    
    $( '.product .overview .content form .fields .attributes .attribute.size .content .select.alt' ).click(function() {
        if ( clickDisabled ) {
            return;
        }
        clickDisabled = true;
        $( '.header__action-list.menu.icons' ).addClass( 'modal-state-visible' );
        $( '.shopify-section.shopify-section__header' ).attr( 'style', 'z-index: -1' );
        $( 'body' ).addClass( 'modal-state' );
        setTimeout(function() {
            clickDisabled = false;
        }, 550 );
        $( '.product .overview .content form .fields .attributes .attribute.size .content .modal' ).addClass( 'delay' );
        setTimeout(function() {
            $( '.product .overview .content form .fields .attributes .attribute.size .content .modal' ).addClass( 'active' );
        }, 100 );
    });
    
    $( '.product .overview .content form .fields .attributes .attribute.size .content .modal .content .terms .term, .product .overview .content form .fields .attributes .attribute.size .content .modal .close, .product .overview .content form .fields .attributes .attribute.size .content .modal .overlay' ).click(function(e) {
        if ( clickDisabled ) {
            return;
        }
        if ( $(this).hasClass( 'term' ) && $(this).closest( 'div[data-product-type="sealant"]' ).length > 0 ){
          return;
        }
        clickDisabled = true;
        if ( e.currentTarget.className.includes( 'disabled' ) ) {
            return;
        }
        setTimeout(function() {
            clickDisabled = false;
        }, 750 );
        $( '.product .overview .content form .fields .attributes .attribute.size .content .modal' ).removeClass( 'active' );
        setTimeout(function() {
            $( '.attributes .attribute.size .content .modal' ).removeClass( 'delay' );
            $( 'body' ).removeClass( 'modal-state' );
            $( '.header__action-list.menu.icons' ).removeClass( 'modal-state-visible' );
            $( '.shopify-section.shopify-section__header' ).attr( 'style', '' );
        }, 750 );
    });
    
    $( '.product .overview .content form .fields .attributes .attribute.size .content .modal .content .terms .term' ).click(function(e) {
        if( e.currentTarget.className.includes( 'disabled' ) ) {
            return;
        }
        $( '.product .overview .content form .fields .attributes .attribute.size .content .modal .content .terms .term' ).not(this).removeClass( 'selected' );
        $(this).addClass( 'selected' );
        if ( clickDisabled ) {
            return;
        }
        clickDisabled = true;
        if ( $( '[data-weight-option="true"]' ).length != 0 ) {
            var targetValue = e.currentTarget.attributes[1].value;
            var weightValue = '';
            if ( targetValue == 'Microfine' ) {
                weightValue = '425g';
            } else if ( targetValue == 'Ultrafine' ) {
                weightValue = '425g';
            } else if ( targetValue == 'Fine' ) {
                weightValue = '425g';
            } else if ( targetValue == 'Chunky' ) {
                weightValue = '425g';
            } else if ( targetValue == 'Extra Chunky' ) {
                weightValue = '425g';
            } else if ( targetValue == 'Super Chunky' ) {
                weightValue = '360g';
            }
            $( '[data-weight-option="true"]' )[0].innerHTML = weightValue;
            $( '[data-weight-option="true"]' )[1].innerHTML = weightValue;
        }
        setTimeout(function(){clickDisabled = false;}, 550 );
    });
    
    if ( window.theme.productType != false ) {
        if ( window.theme.productType != localStorage.getItem( 'productType' ) ) {
            localStorage.setItem( 'productType', window.theme.productType );
            localStorage.setItem( 'groutColour', 'Grey' );
            localStorage.setItem( 'glitterSize', 'Ultrafine' );
        }
    }
    var groutColour, glitterSize;
    if ( localStorage.getItem( 'groutColour' ) ) {
        groutColour = localStorage.getItem( 'groutColour' );
        $(document).ready(function() {
            var $groutItem = $( '.product .overview .content form .fields .attributes .attribute.size[data-product-type="grout"] .content .modal .content .terms .term[value="' + groutColour + '"]' );
            if ( $groutItem.length ) {
                // $groutItem.trigger( 'click' );
            } else {
                localStorage.setItem( 'groutColour', $( '.product .overview .content form .fields .attributes .attribute.size[data-product-type="grout"] .content .modal .content .terms .term.selected' ).attr( 'value' ) );
            }
        });
    }
    if( localStorage.getItem( 'glitterSize' ) ) {
        glitterSize = localStorage.getItem( 'glitterSize' );
    }
    
    $( '.product .overview .content form .fields .attributes .attribute.size[data-product-type="grout"] .content .modal .content .terms .term' ).click(function(e) {
        localStorage.setItem( 'groutColour', $(this).attr('value') );
        localStorage.setItem( 'productType', window.theme.productType );
        if ( e.currentTarget.className.includes( 'disabled' ) ) {
            return;
        }
        $( '.product .overview .content form .fields .attributes .attribute.size .content .modal .content .terms .term' ).not(this).removeClass( 'selected' );
        $(this).addClass( 'selected' );
        var groutColour = localStorage.getItem( 'groutColour' );
        $(document).ready(function() {
          if ( groutColour == 'Grey' ) {
                $( '.product .overview .content form .fields .attributes .attribute.size[data-product-type="grout"] .content .select .swatch' ).css( 'background-color', '#828282' );
            } else if ( groutColour == 'Light Grey' ) {
                $( '.product .overview .content form .fields .attributes .attribute.size[data-product-type="grout"] .content .select .swatch' ).css( 'background-color', '#B6B6B6' );
            } else if ( groutColour == 'Jet Black' ) {
                $( '.product .overview .content form .fields .attributes .attribute.size[data-product-type="grout"] .content .select .swatch' ).css( 'background-color', '#030303' );
            } else if ( groutColour == 'Bright White' ) {
                $( '.product .overview .content form .fields .attributes .attribute.size[data-product-type="grout"] .content .select .swatch').css( 'background-color', '#E8E8E8' );
            }
        });
        if ( clickDisabled ) {
            return;
        }
        clickDisabled = true;
        setTimeout(function() {
            clickDisabled = false;
        }, 550 );
    });
    
    $( '.product .overview .content form .fields .attributes .attribute.glittersealant .content .select.alt' ).click(function() {
        if ( clickDisabled ) {
            return;
        }
        clickDisabled = true;
        $( '.header__action-list.menu.icons' ).addClass( 'modal-state-visible' );
        $( '.shopify-section.shopify-section__header' ).attr( 'style', 'z-index: -1' );
        $( 'body' ).addClass( 'modal-state' );
        setTimeout(function() {
            clickDisabled = false;
        }, 550 );
        $( '.product .overview .content form .fields .attributes .attribute.glittersealant .content .modal' ).addClass( 'delay' );
        setTimeout(function() {
            $( '.product .overview .content form .fields .attributes .attribute.glittersealant .content .modal' ).addClass( 'active' );
        }, 100 );
    });
    
    $( '.product .overview .content form .fields .attributes .attribute.glittersealant .content .modal .content .terms .term, .product .overview .content form .fields .attributes .attribute.glittersealant .content .modal .close, .product .overview .content form .fields .attributes .attribute.glittersealant .content .modal .overlay' ).click(function(e) {
        if ( clickDisabled ) {
            return;
        }
        clickDisabled = true;
        if ( e.currentTarget.className.includes( 'disabled' ) ) {
            return;
        }
        setTimeout(function() {
            clickDisabled = false;
        }, 750 );
        $( '.product .overview .content form .fields .attributes .attribute.glittersealant .content .modal' ).removeClass( 'active' );
        setTimeout(function() {
            $( '.attributes .attribute.glittersealant .content .modal' ).removeClass( 'delay' );
            $( 'body' ).removeClass( 'modal-state' );
            $( '.header__action-list.menu.icons' ).removeClass( 'modal-state-visible' );
            $( '.shopify-section.shopify-section__header' ).attr( 'style', '' );
        }, 750 );
    });
    
    $( '.product .overview .content form .fields .attributes .attribute.glittersealant .content .modal .content .terms .term' ).click(function(e) {
        if ( e.currentTarget.className.includes( 'disabled' ) ) {
            return;
        }
        $( '.product .overview .content form .fields .attributes .attribute.glittersealant .content .modal .content .terms .term' ).not(this).removeClass( 'selected' );
        $(this).addClass( 'selected' );
    });
    
    $( '.product .overview .content form .fields .attributes .attribute.sealant .content .select.alt' ).click(function() {
        $( '.header__action-list.menu.icons' ).addClass( 'modal-state-visible' );
        $( '.shopify-section.shopify-section__header' ).attr( 'style', 'z-index: -1' );
        $( 'body' ).addClass( 'modal-state' );
        $( '.product .overview .content form .fields .attributes .attribute.sealant .content .modal' ).addClass( 'delay' );
        setTimeout(function() {
            $( '.product .overview .content form .fields .attributes .attribute.sealant .content .modal' ).addClass( 'active' );
        }, 100 );
    });
    
    $( '.product .overview .content form .fields .attributes .attribute.sealant .content .modal .content .terms .term, .product .overview .content form .fields .attributes .attribute.sealant .content .modal .close, .product .overview .content form .fields .attributes .attribute.sealant .content .modal .overlay' ).click(function(e) {
        if ( clickDisabled ) {
            return;
        }
        clickDisabled = true;
        if ( e.currentTarget.className.includes( 'disabled' ) ) {
            return;
        }
        setTimeout(function() {
            clickDisabled = false
        }, 750 );
        $( '.product .overview .content form .fields .attributes .attribute.sealant .content .modal' ).removeClass( 'active' );
        setTimeout(function() {
            $( '.attributes .attribute.sealant .content .modal' ).removeClass( 'delay' );
            $( 'body' ).removeClass( 'modal-state' );
            $( '.header__action-list.menu.icons' ).removeClass( 'modal-state-visible' );
            $( '.shopify-section.shopify-section__header' ).attr( 'style', '' );
        }, 750 );
    });
    
    $( '.product .overview .content form .fields .attributes .attribute.sealant .content .modal .content .terms .term' ).click(function(e) {
        if ( e.currentTarget.className.includes( 'disabled' ) ) {
            return;
        }
        $( '.product .overview .content form .fields .attributes .attribute.sealant .content .modal .content .terms .term' ).not(this).removeClass( 'selected' );
        $(this).addClass( 'selected' );
    });
    
    $( '.product .overview .content form .fields .attributes .attribute.finish .content .select.alt' ).click(function() {
        if ( clickDisabled ) {
            return;
        }
        clickDisabled = true;
        $( '.header__action-list.menu.icons' ).addClass( 'modal-state-visible' );
        $( '.shopify-section.shopify-section__header' ).attr( 'style', 'z-index: -1' );
        $( 'body' ).addClass( 'modal-state' );
        setTimeout(function() {
            clickDisabled = false;
        }, 550 );
        $( '.product .overview .content form .fields .attributes .attribute.finish .content .modal' ).addClass( 'delay' );
        setTimeout(function() {
            $( '.product .overview .content form .fields .attributes .attribute.finish .content .modal' ).addClass( 'active' );
        }, 100 );
    });
    
    $( '.product .overview .content form .fields .attributes .attribute.finish .content .modal .content .terms .term, .product .overview .content form .fields .attributes .attribute.finish .content .modal .close, .product .overview .content form .fields .attributes .attribute.finish .content .modal .overlay' ).click(function(e) {
        if ( clickDisabled ) {
            return;
        }
        clickDisabled = true;
        if ( e.currentTarget.className.includes( 'disabled' ) ) {
            return;
        }
        setTimeout(function() {
            clickDisabled = false;
        }, 750 );
        $( '.product .overview .content form .fields .attributes .attribute.finish .content .modal' ).removeClass( 'active' );
        setTimeout(function() {
            $( '.product .overview .content form .fields .attributes .attribute.finish .content .modal' ).removeClass( 'delay' );
            $( 'body' ).removeClass( 'modal-state' );
            $( '.header__action-list.menu.icons' ).removeClass( 'modal-state-visible' );
            $( '.shopify-section.shopify-section__header' ).attr( 'style', '' );
        }, 750 );
    });
    
    $( '.product .overview .content form .fields .attributes .attribute.finish .content .modal .content .terms .term' ).click(function(e) {
        if ( clickDisabled ) {
            return;
        }
        clickDisabled = true;
        if ( e.currentTarget.className.includes( 'disabled' ) ) {
            return;
        }
        $( '.product .overview .content form .fields .attributes .attribute.finish .content .modal .content .terms .term' ).not(this).removeClass( 'selected' );
        $(this).addClass( 'selected' );
        $( '.product .overview .content form .blocks.two .price .text' ).text( $(this).data( 'optionPrice' ) );
        $( '.navigation .container .content .links a[data-option="price"]' ).text( $(this).data( 'optionPrice' ) );
        setTimeout(function() {
            clickDisabled = false;
        }, 550 );
    });
    
    $( '.product .overview .content form .fields .attributes .attribute.weight .content .select.alt' ).click(function() {
        if ( clickDisabled ) {
            return;
        }
        clickDisabled = true;
        $( '.header__action-list.menu.icons' ).addClass( 'modal-state-visible' );
        $( '.shopify-section.shopify-section__header' ).attr( 'style', 'z-index: -1' );
        $( 'body' ).addClass( 'modal-state' );
        setTimeout(function() {
            clickDisabled = false;
        }, 550 );
        $( '.product .overview .content form .fields .attributes .attribute.weight .content .modal' ).addClass( 'delay' );
        setTimeout(function() {
            $( '.product .overview .content form .fields .attributes .attribute.weight .content .modal' ).addClass( 'active' );
        }, 100 );
    });
    
    $( '.product .overview .content form .fields .attributes .attribute.weight .content .modal .content .terms .term, .product .overview .content form .fields .attributes .attribute.weight .content .modal .close, .product .overview .content form .fields .attributes .attribute.weight .content .modal .overlay' ).click(function(e) {
        if ( clickDisabled ) {
            return;
        }
        clickDisabled = true;
        if ( e.currentTarget.className.includes( 'disabled' ) ) {
            return;
        }
        setTimeout(function() {
            clickDisabled = false;
        }, 750 );
        $( '.product .overview .content form .fields .attributes .attribute.weight .content .modal' ).removeClass( 'active' );
        setTimeout(function() {
            $( '.product .overview .content form .fields .attributes .attribute.weight .content .modal' ).removeClass( 'delay' );
            $( 'body' ).removeClass( 'modal-state' );
            $( '.header__action-list.menu.icons' ).removeClass( 'modal-state-visible' );
            $( '.shopify-section.shopify-section__header' ).attr( 'style', '' );
        }, 750 );
    });
    
    $( '.product .overview .content form .fields .attributes .attribute.weight .content .modal .content .terms .term' ).click(function(e) {
        if( e.currentTarget.className.includes( 'disabled' ) ) {
            return;
        }
        $( '.product .overview .content form .fields .attributes .attribute.weight .content .modal .content .terms .term' ).not(this).removeClass( 'selected' );
        $(this).addClass( 'selected' );
        $( '.product .overview .content form .blocks.two .price .text' ).text( $(this).data( 'optionPrice' ) );
        $( '.navigation .container .content .links a[data-option="price"]' ).text( $(this).data( 'optionPrice' ) );
        if ( clickDisabled ) {
            return;
        }
        clickDisabled = true;
        setTimeout(function() {
            clickDisabled = false;
        }, 750 );
    });
    
    /* $(document).ready(function() {
        if ( groutColour && $( '.product .overview .content form .fields .attributes .attribute.size[data-product-variant="rmgg"]' ).length > 0 ) {
            $( '.product .overview .content form .fields .attributes .attribute.size .content .modal .content .terms .term.selected' ).removeClass( 'selected' );
            if ( $( 'option[selected="selected"]' ) ) {
                $( 'option[selected="selected"]' ).removeAttr( 'selected' );
            }
            for ( let i = 0; i <= $( '.product .overview .content form .fields .attributes .attribute.size .content .modal .content .terms .term' ).length - 1; i++ ) {
                if ( $( '.product .overview .content form .fields .attributes .attribute.size .content .modal .content .terms .term' )[i].attributes[1].value == groutColour ) {
                    $( '.product .overview .content form .fields .attributes .attribute.size .content .modal .content .terms .term[value="' + groutColour + '"]' ).addClass( 'selected' );
                    $( '.product .overview .content form .fields .attributes .attribute.size[data-product-type="grout"] .content .select .text' )[0].innerText = groutColour;
                    if ( groutColour == 'Grey' ) {
                        $( '.product .overview .content form .fields .attributes .attribute.size[data-product-type="grout"] .content .select .swatch' ).css( 'background-color', '#828282' );
                    } else if ( groutColour == 'Light Grey' ) {
                        $( '.product .overview .content form .fields .attributes .attribute.size[data-product-type="grout"] .content .select .swatch' ).css( 'background-color', '#B6B6B6' );
                    } else if ( groutColour == 'Jet Black' ) {
                        $( '.product .overview .content form .fields .attributes .attribute.size[data-product-type="grout"] .content .select .swatch' ).css( 'background-color', '#030303' );
                    } else if ( groutColour == 'Bright White' ) {
                        $( '.product .overview .content form .fields .attributes .attribute.size[data-product-type="grout"] .content .select .swatch').css( 'background-color', '#E8E8E8' );
                    }
                }
                var replace = `^${groutColour}`;
                var re = new RegExp(replace,"g");
                if ( $( 'option' )[i].innerText.match(re) ) {
                    var sku = $( 'option' )[i].attributes[1].value;
                    $( 'option[data-sku="' + sku + '"' )[0].setAttribute( 'selected', 'selected' );
                }
            }
        }
    }); */
    
    var enabledSize = true;
    
    if ( glitterSize && $( 'option[disabled="disabled"]' ).length != 0 ) {
        $( 'option[disabled="disabled"]' ).each(function() {
            if( this.innerText.includes('/ ' + glitterSize + " /" ) ) {
                enabledSize = false;
            }
        });
    }
    
    $(document).ready(function() {
        if( glitterSize && $( '.product .overview .content form .fields .attributes .attribute.size').length > 0 && localStorage.getItem( 'productType' ) != 'Glitter Sealant' && enabledSize && localStorage.getItem( 'productType' ) != 'Ready Mixed Glitter Grout' ) {
            if( $( 'option' ).length > 1 && glitterSize != 'Shaped' ) {
                $( '.product .overview .content form .fields .attributes .attribute.size .content .modal .content .terms .term.selected' ).removeClass( 'selected' );
                if ( $( 'option[selected="selected"]' ) ) {
                    $( 'option[selected="selected"]' ).removeAttr( 'selected' );
                }
                for ( let i = 0; i <= $( '.product .overview .content form .fields .attributes .attribute.size .content .modal .content .terms .term' ).length - 1; i++ ) {
                    if ( $( '.product .overview .content form .fields .attributes .attribute.size .content .modal .content .terms .term' )[i].attributes[1].value == glitterSize ) {
                        $( '.product .overview .content form .fields .attributes .attribute.size .content .modal .content .terms .term[value="'+ glitterSize +'"]' ).addClass( 'selected' );
                        $( '.product .overview .content form .fields .attributes .attribute.size .content .select .text' )[0].innerText = glitterSize;
                    }
                    if ( $( 'option' )[i] && $( 'option' )[i].innerText.includes( "/ " + glitterSize ) ) {
                        var sku = $( 'option' )[i].attributes[1].value;
                        $( 'option[data-sku="' + sku + '"' )[0].setAttribute( 'selected', 'selected' );
                    }
                }
            }
        }
    });
    
    $( '.product .overview .content form .fields .attributes .attribute.color .content .modal .content .terms .term' ).click(function(e) {
        if ( $( '.product .overview .content form .fields .attributes .attribute.color[data-type="powder"] .content .modal .content .terms .term' ).length == 0 && $( '.product .overview .content form .fields .attributes .attribute.color[data-type="paint"]' ).length !== 1 && $( '.product .overview .content form .fields .attributes .attribute.size .content .modal .content .terms .term.selected' ).length > 0 ) {
            e.preventDefault();
        }
        $(document).ready(function() {
            if( e.currentTarget.children[0].href && $( '.product .overview .content form .fields .attributes .attribute.color[data-product-type="rmgg"]' ).length > 0 ) {
                localStorage.setItem('groutColour', $( '.product .overview .content form .fields .attributes .attribute.size[data-product-type="grout"] .content .modal .content .terms .term.selected' )[0].attributes[1].value );
                localStorage.setItem('productType', window.theme.productType );
                document.location.href = e.currentTarget.children[0].href;
            } else if( e.currentTarget.children[0].href && $( '.product .overview .content form .fields .attributes .attribute.size[data-product-type="glitter"]' ).length > 0 && $( '.product .overview .content form .fields .attributes .attribute.color[data-type="paint"] .content .modal .content .terms .term' ).length == 0 ) {
                localStorage.setItem('glitterSize', $( '.product .overview .content form .fields .attributes .attribute.size .content .modal .content .terms .term.selected' )[0].attributes[1].value );
                localStorage.setItem('productType', window.theme.productType );
                document.location.href = e.currentTarget.children[0].href;
            }
        });
        if ( e.currentTarget.className.includes( 'disabled' ) ) {
            return;
        }
        $( '.product .overview .content form .fields .attributes .attribute.color .content .modal .content .terms .term' ).not(this).removeClass( 'selected' );
        $(this).addClass( 'selected' );
        $( '.product .overview .content form .blocks.two .price .text' ).text( $(this).data( 'optionPrice' ) );
        $( '.navigation .container .content .links a[data-option="price"]' ).text( $(this).data( 'optionPrice' ) );
        if ( clickDisabled ) {
            return;
        }
        clickDisabled = true;
        setTimeout(function() {
            clickDisabled = false;
        }, 750 );
    });
    
    /*

    $( '.button.small.alt.unmute' ).click(function() {
        if ( $(this).hasClass( 'native' ) ) {
            return false;
        }
        var $parent = $(this).closest( '.block.two' );
        var player = new Vimeo.Player( $parent.find( '.video' ) );
        player.setMuted(false);
        $parent.find( '.buttons' ).removeClass( 'mute' ).addClass( 'unmute' );
    });

     $( '.button.small.alt.mute' ).click(function() {
        if ( $(this).hasClass( 'native' ) ) {
            return false;
        }
        var $parent = $(this).closest( '.block.two' );
        var player = new Vimeo.Player( $parent.find( '.video' ) );
        player.setMuted(true);
        $parent.find( '.buttons' ).removeClass( 'unmute' ).addClass( 'mute' );
    });
    
    $(document).ready(function() {
        const productLinks = window.pseudo.productLinks; 
        const swatchImages = window.pseudo.swatchImages;
        
        if ( $( '[data-colour-caption]' ) ) {
            $( '[data-colour-caption]' ).each(function(i) {
                var captions = $( '[data-colour-caption]' )[i].dataset.colourCaption.split( ', ' );
                if( captions.length > 1 ) {
                    var colourCaption = "<div class='attributes'>";
                    captions.forEach(function(e) {
                        colourCaption += "<div class='attribute color'><a href='" + productLinks[window.theme.productType][e] + "'><div class='swatch' style='background-image: url(\"" + swatchImages[e] + "\")'></div></a></div>";
                    });
                    colourCaption += "</div>";
                    $( '[data-colour-caption]' )[i].parentElement.insertAdjacentHTML( "afterbegin", colourCaption );
                } else {
                    $( '[data-colour-caption]' )[i].style.backgroundImage = 'url(' + swatchImages[$( '[data-colour-caption]' )[i].dataset.colourCaption] + ')';
                    $( '[data-colour-caption]' )[i].parentElement.href = productLinks[window.theme.productType][$( '[data-colour-caption]' )[i].nextSibling.innerText];
                }
            });
            $( '[data-temp]' ).remove();
        }
        $( '.banner .slide.one .content' ).find( '[data-variant-pos="' + $( '.size .modal .selected' ).data( 'variantPos' ) +'"' ).addClass( 'active' );
        $( '.banner .slide.two .content' ).find( '[data-variant-pos="' + $( '.size .modal .selected' ).data( 'variantPos' ) +'"' ).addClass( 'active' );
    });
    
    */
    
    $(function() {
    
        if ( $( 'body' ).hasClass( 'index' ) ) {
    
            const $homeGlitterSlider = $(document).find( '.home .categories .category.one .content .blocks .block.three .blocks .block .products .slider' );
    
            const swiperHomeTwo = new Swiper( '.home .categories .category.one .slider', {
                containerModifierClass: 'slide-',
                slideActiveClass: 'active',
                slideBlankClass: 'blank',
                slideClass: 'slide',
                slideNextClass: 'next',
                slidePrevClass: 'previous',
                slideVisibleClass: 'visible',
                wrapperClass: 'slides',
                speed: 750,
                centerInsufficientSlides: true,
                simulateTouch: true,
                touchRatio: 1,
                navigation: {
                    disabledClass: 'disabled',
                    nextEl: '.home .categories .category.one .slider .buttons .right',
                    prevEl: '.home .categories .category.one .slider .buttons .left',
                },
                breakpoints: {
                    0: {
                        spaceBetween: 12,
                        slidesPerView: 2,
                    },
                    600: {
                        spaceBetween: 18,
                        slidesPerView: 3,
                    },
                    900: {
                        spaceBetween: 20,
                        slidesPerView: 4,
                    }
                }
            });
    
            const $nav = '.home .categories .category.one .content .blocks .block.three .blocks .block .filters .buttons ul li';
    
            $(document).on( 'click', $nav, function(e) {
                e.preventDefault();
                const _this = $(this);
                $( '.home .categories .category.one .content .blocks .block.three .blocks .block .filters .buttons ul li.active' ).removeClass( 'active' );
                _this.addClass( 'active' );
                renderGlitters( _this.data( 'handle' ) );
            });

            function renderGlitters(nav) {
                const template = 'home-glitters';
                const url      = window.routes.searchUrl + '?view=' + template + '&q=' + nav;
                fetch( url, {
                    credentials: 'same-origin',
                    method: 'GET'
                }).then(function (response) {
                    response.text().then(function (content) {
                        $homeGlitterSlider.find( '.slides' ).html( content );
                        setTimeout(() => {
                            swiperHomeTwo.update();
                            swiperHomeTwo.slideTo(0);
                            Utils.generateProductReviews( $homeGlitterSlider );
                        }, 100);          
                    });
                });
            }

            const swiperHomeThree = new Swiper( '.home .categories .category.three .slider', {
                containerModifierClass: 'slide-',
                noSwipingClass: 'alt',
                slideActiveClass: 'active',
                slideBlankClass: 'blank',
                slideClass: 'slide',
                slideNextClass: 'next',
                slidePrevClass: 'previous',
                slideVisibleClass: 'visible',
                wrapperClass: 'slides',
                speed: 750,
                navigation: {
                    disabledClass: 'disabled',
                    nextEl: '.home .categories .category.three .buttons .next',
                    prevEl: '.home .categories .category.three .buttons .previous',
                },
                breakpoints: {
                    0: {
                        spaceBetween: 12,
                        slidesPerView: 2,
                    },
                    750: {
                        spaceBetween: 18,
                        slidesPerView: 3,
                    },
                    1025: {
                        spaceBetween: 20,
                        slidesPerView: 4,
                    }
                }
            });          
    
            const swiperHomeFour = new Swiper( '.home .categories .category.four .slider', {
                containerModifierClass: 'slide-',
                noSwipingClass: 'alt',
                slideActiveClass: 'active',
                slideBlankClass: 'blank',
                slideClass: 'slide',
                slideNextClass: 'next',
                slidePrevClass: 'previous',
                slideVisibleClass: 'visible',
                wrapperClass: 'slides',
                speed: 750,
                navigation: {
                    disabledClass: 'disabled',
                    nextEl: '.home .categories .category.four .buttons .next',
                    prevEl: '.home .categories .category.four .buttons .previous',
                },
                breakpoints: {
                    0: {
                        spaceBetween: 12,
                        slidesPerView: 2,
                    },
                    750: {
                        spaceBetween: 18,
                        slidesPerView: 3,
                    },
                    1025: {
                        spaceBetween: 20,
                        slidesPerView: 4,
                    }
                }
            });

            Utils.generateProductReviews( $homeGlitterSlider );
            Utils.generateProductReviews( '.home .categories .category.two .content .blocks .block.five' );
            Utils.generateProductReviews( '.home .categories .category.three' );
            Utils.generateProductReviews( '.home .categories .category.four' );
    
        }
    
    });

    $( '.product .overview .content .form .blocks.three .block .fields .attributes .attribute.size.paint.alt .content .terms .term:nth-child(1)' ).click(function() {
        $( '.product .banner .content .slider.one' ).attr( 'data-slider', 'tin' );
    });

    $( '.product .overview .content .form .blocks.three .block .fields .attributes .attribute.size.paint.alt .content .terms .term:nth-child(2)' ).click(function() {
        $( '.product .banner .content .slider.one' ).attr( 'data-slider', 'sample' );
    });

     $.fn.isOnScreen = function() {
        var win = $(window);    
        var viewport = {
            top : win.scrollTop(),
            left : win.scrollLeft()
        };
        viewport.right = viewport.left + win.width();
        viewport.bottom = viewport.top + win.height();    
        var bounds = this.offset();
        bounds.right = bounds.left + this.outerWidth();
        bounds.bottom = bounds.top + this.outerHeight();    
        return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));    
    };

    $(document).ready( function() {
      
        var $window = $(window);
        function swiperClass() {
            var windowSize = document.body.clientWidth;
            if (windowSize < 1025) {
                $( '.product .banner .content .slider .slides .slide .content .image' ).removeClass( 'swiper-zoom-target' );
            } else if (windowSize >= 1026) {
                $( '.product .banner .content .slider .slides .slide .content .image' ).addClass( 'swiper-zoom-target' );
            };
        }
        swiperClass();
        $(window).resize( swiperClass );

        function playViewportVideo() {
            $( '.video' ).each(function() {
                if ( $(this).isOnScreen() ) {
                    var player = new Vimeo.Player( $(this) );
                    player.play();
                    $(this).addClass( 'playing' );
                    $(this).removeClass( 'paused' );
                } else {
                    var player = new Vimeo.Player( $(this) );
                    player.pause();
                    $(this).addClass( 'paused' );
                    $(this).removeClass( 'playing' );
                }
            });
        }

        if ( $( 'body' ).hasClass( 'index' ) ) {
            playViewportVideo();  
            $(window).on( 'scroll', function () {
                playViewportVideo();
            });
            var iframe = document.querySelector( '.home .banner .content .blocks .block.two .blocks .block .video iframe' );
            var player = new Vimeo.Player(iframe);
            player.on( 'timeupdate', function(data) {
                if (data.seconds >= 4 && data.seconds < 10) {
                    swiperHomeOne.slideTo(2);
                } else if (data.seconds >= 10 && data.seconds < 17) {
                    swiperHomeOne.slideTo(3);
                } else if (data.seconds >= 17 && data.seconds < 23) {
                    swiperHomeOne.slideTo(4);
                } else if (data.seconds >= 23) {
                    swiperHomeOne.slideTo(1);
                }
            });
        }

        if ( $( 'body' ).hasClass( 'article' ) ) {
            let swiper_breakpoints = {
                  0: {
                      spaceBetween: 12,
                      slidesPerView: 2,
                  },
                  600: {
                      spaceBetween: 18,
                      slidesPerView: 3,
                  },
                  900: {
                      spaceBetween: 20,
                      slidesPerView: 4,
                  }
              };          
            $('.post .article .content .blocks .block .slider').each(function () {
                if ( $( '.slides .slide', this ).length ) {
                    Utils.generateProductsSlider( '.post .article .content .blocks .block .slider', swiper_breakpoints, $(this).data( 'slider' ) );
                } else {
                    $(this).remove();
                }
            });          
        }
      
        localStorage.setItem( 'previousURL', window.location.href );  

        renderRecentlyViewedProducts();
        
        function renderRecentlyViewedProducts() {
            var items = JSON.parse( localStorage.getItem('recentlyViewedProducts') || '[]' );
            if ( items.includes( window.currentProductId ) ) {
                items.splice(items.indexOf( window.currentProductId ), 1);
            }
            if ( items.length == 0 ) {
                $( '.viewed' ).parent().remove();
            } else {                
                var queryString = items.map(function (item) {
                    return 'id:' + item;
                }).join(' OR ');
                if ( queryString != '' ) {
                    var template = 'static-viewed-recently';
                    fetch("".concat(window.routes.searchUrl, "?view=").concat(template, "&type=product&q=").concat(queryString), {
                        credentials: 'same-origin',
                        method: 'GET'
                    }).then(function (response) {
                      response.text().then(function (content) {
                          $( '.viewed' ).parent().html( content );                      
                          const swiperProductTwo = new Swiper( '.viewed .slider', {
                              containerModifierClass: 'slide-',
                              noSwipingClass: 'alt',
                              slideActiveClass: 'active',
                              slideBlankClass: 'blank',
                              slideClass: 'slide',
                              slideNextClass: 'next',
                              slidePrevClass: 'previous',
                              slideVisibleClass: 'visible',
                              wrapperClass: 'slides',
                              speed: 750,
                              navigation: {
                                  disabledClass: 'disabled',
                                  nextEl: '.viewed .slider .buttons .next',
                                  prevEl: '.viewed .slider .buttons .previous',
                              },
                              breakpoints: {
                                  300: {
                                      spaceBetween: 12,
                                      slidesPerView: 2
                                  },
                                  600: {
                                      spaceBetween: 17,
                                      slidesPerView: 3
                                  },
                                  900: {
                                      spaceBetween: 22,
                                      slidesPerView: 4
                                  }
                              }
                          });  
                        }).then(function () {
                            Utils.generateProductReviews( '.viewed .slider' );
                        });
                    });
                }
            }
        }

        $( '.home .banner .content .blocks .block.three' ).append( $( '.brands' ) ); 
        
        $( '.auth.account .toggle' ).click(function(e) {
            $( '.account section.form' ).toggleClass( 'alt' );
        });

        $( '.about .timeline .content .sections .section .blocks .block .events .block .blocks .block .event .blocks .block .blocks .block .blocks .block .icons .icon' ).click(function() {
            $( '.about .timeline .content .sections .section .blocks .block .events .block .blocks .block .event .blocks .block .blocks .block .blocks .block .icons .icon' ).toggleClass( 'active' );
        });

        if ( $( '.subscribe.alt' ).length ) {
            function cookieExists(name) {
                return document.cookie.split(';').some(function(cookie) {
                    return cookie.trim().startsWith(name + '=');
                });
            }

            if ( ! cookieExists( 'welcomeSubscription' ) ) {
                $( '.subscribe.alt' ).addClass( 'active' );
            }
        }     
      
    });
